import { useQuery } from "@tanstack/react-query"
import { fetchStatistics } from "@/api/app/citizen/home/fetchers"

export const useStatistics = () => (
    useQuery({
        queryKey: ["citizen", "statistics", "home"],
        queryFn: fetchStatistics
    })
)

export const prefetchStatistics = async (queryClient) => (
    await queryClient.prefetchQuery({
        queryKey: ["citizen", "statistics", "home"],
        queryFn: fetchStatistics
    })
)